import { createTheme } from '@mui/material';
var augmentColor = createTheme().palette.augmentColor;
export var palette = {
    primary: augmentColor({
        color: {
            main: '#0046BF',
        },
    }),
    secondary: augmentColor({
        color: {
            main: '#95B4FF',
        },
    }),
    info: augmentColor({
        color: {
            main: '#62cae6',
        },
    }),
    text: {
        primary: '#1E1D1B',
        dark: '#323232',
    },
    common: {
        black: '#122b3b',
        white: '#fff',
        'faux-white': '#F4F4F4',
        'faux-black': '#122B3B',
    },
    blue: {
        light: '#E6EDF9',
        medium: '#8AAAE2',
        dark: '#2A64CA',
    },
    shadow: {
        main: '#00000022',
    },
    custom: {
        normalCategory: augmentColor({
            color: { main: '#39BB2D' },
        }),
        mildCategory: augmentColor({
            color: { main: '#F97D00' },
        }),
        moderateCategory: augmentColor({
            color: { main: '#FF0000' },
        }),
    },
};
